var _excluded = ["options", "menuClassName", "triggerClassName", "title", "disabled", "iconSize", "contentWidth"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import ActionsMenu from "./actions-menu";
import Icon from "../elements/icon";
import classNames from "classnames";

var ThreeDotActionsMenu = function ThreeDotActionsMenu(_ref) {
  var options = _ref.options,
      menuClassName = _ref.menuClassName,
      triggerClassName = _ref.triggerClassName,
      title = _ref.title,
      disabled = _ref.disabled,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 1 : _ref$iconSize,
      contentWidth = _ref.contentWidth,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ActionsMenu, _extends({
    options: options,
    menuClassName: menuClassName,
    triggerClassName: triggerClassName,
    disabled: disabled,
    title: title,
    trigger: function trigger(_ref2) {
      var isOpen = _ref2.isOpen;
      return /*#__PURE__*/React.createElement(Icon, {
        title: "prospect actions",
        className: classNames("et--three-dot-actions-menu--trigger", {
          "is-active": isOpen
        }),
        size: iconSize,
        icon: "more-horiz"
      });
    }
  }, rest));
};

ThreeDotActionsMenu.propTypes = {
  disabled: PropTypes.bool,
  iconSize: PropTypes.number,
  menuClassName: PropTypes.string,
  options: PropTypes.array,
  title: PropTypes.string,
  triggerClassName: PropTypes.string,
  contentWidth: PropTypes.number
};
export default ThreeDotActionsMenu;